import {Directive, ElementRef, HostListener, Inject, OnInit} from '@angular/core';
import {RESIZABLE_HANDLE, RESIZABLE_PARENT} from '@shared/resizable/injection-tokens';
import {ResizableDirective} from '@shared/resizable/resizable.directive';
import {Point} from '@angular/cdk/drag-drop';

@Directive({
  selector: '[resizableHandle]',
  providers: [{provide: RESIZABLE_HANDLE, useExisting: ResizableHandleDirective}],
})
export class ResizableHandleDirective implements OnInit {

  constructor(@Inject(RESIZABLE_PARENT) private parent: ResizableDirective,
              public element: ElementRef<HTMLElement>) { }

  ngOnInit() {
    this.parent.registerHandle(this);
  }

  @HostListener('mousedown', ['$event']) private mouseDown(event: MouseEvent) {
    event.stopPropagation();

    const startPoint: Point = {
      x: event.clientX,
      y: event.clientY
    };

    this.parent.startResize(startPoint);
  }

}
